import { Theme } from '@mui/material';

export const circularStyle = {
  color: 'button.outlinedDark',
  // minus/trashs
  '&:hover': {
    backgroundColor: 'icon.hover',
  },
  '&:disabled': {
    color: (theme: Theme) => (theme.palette.theme == 'lio' ? `${theme.palette.icon.disabled}` : 'icon.disabled'),
    backgroundColor: 'transparent',
  },
} as const;

export const circularDarkStyle = {
  color: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.white' : 'background.light'),
  // notification bell/profile
  '&:hover': {
    backgroundColor: 'icon.backgroundDark',
  },
  '&:disabled': {
    color: 'icon.disabled',
    backgroundColor: 'transparent',
  },
} as const;

export const commonRoundedStyle = {
  // backgroundColor: 'green', // unknown
  borderRadius: '4px',
  '& .MuiTouchRipple-root span': {
    borderRadius: '4px',
  },
} as const;

export const roundedStyle = {
  ...circularStyle,
  ...commonRoundedStyle,
} as const;
